import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import IProduct, { ICalorie, ProdutoParmDTO } from '@/interfaces/product';


export function getProductTpPatientConfigsOptions() : Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PRODUCTS_TP_PATIENT_CONFIGS}`)).pipe(
    map((r: any) => r.data),
  );
}

function getProducts(filter: any = {}): Observable<IProduct[]> {
  return from(
    apiClient.get(ENDPOINTS.PRODUCTS, {
      ativo: filter.status,
    }),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}
export function getProductDetails(id: number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PRODUCTS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}
export function getProductAlterHist(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PRODUCTS}/${id}/historicos/alteracoes`)).pipe(
    map((r: any) => r.data),
  );
}

export function saveProduct(parm: ProdutoParmDTO, file: any): Observable<any> {
  return from(apiClient.postMultipartFormData(ENDPOINTS.PRODUCTS, {parm, file})).pipe(
    map((r: any) => r.data),
  );
}

export function updateProduct(parm: ProdutoParmDTO, file: any): Observable<any> {
  return from(apiClient.putMultipartFormData(ENDPOINTS.PRODUCTS, {parm, file})).pipe(
    map((r: any) => r.data),
  );
}

function deleteProduct(id: string): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.PRODUCTS}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}
function saveFile(id: number, payload: any): Observable<any> {
  return from(
    apiClient.putMultipartFormData(
      `${ENDPOINTS.PRODUCTS}/${id}${ENDPOINTS.PRODUCTS_FILE}`,
      payload,
    ),
  ).pipe(map((r: any) => r.data));
}
function deleteFile(id: string): Observable<any> {
  return from(
    apiClient.delete(`${ENDPOINTS.PRODUCTS}/${id}${ENDPOINTS.PRODUCTS_FILE}`),
  ).pipe(map((r: any) => r.data));
}
function getCalories(): Observable<ICalorie[]> {
  return from(apiClient.get(ENDPOINTS.PRODUCT_CALORIES)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export {
  getProducts,
  deleteProduct,
  saveFile,
  deleteFile,
  getCalories,
};
